import { When } from 'react-if';
import {
    Body1,
    getPageUrl,
    PhotoCollage,
    useAnalyticsClickEvent,
} from 'rwl-ui';

import { DesktopHeader } from './DetailsHeader';
import { useJob } from '../../fetchers';
import { useCallback } from 'react';
import { ClickTargets } from 'rwl-shared/dist/models/analytics';
import { sortedMedia } from '../../utils';
import type { FeaturedMedia } from 'rwl-shared/dist/models';

export const LgJobDetails = () => {
    const { job, setSelectedMedia } = useJob();
    const sendClickEvent = useAnalyticsClickEvent();
    const onSeeAllMedia = useCallback(() => {
        sendClickEvent({
            url: getPageUrl(),
            target: ClickTargets.SEE_ALL,
            workSite: job?.id,
        });
    }, [job, sendClickEvent]);

    return (
        <>
            <DesktopHeader />
            <When condition={!!job}>
                <PhotoCollage
                    media={sortedMedia(job?.media || [])}
                    onClickMedia={(media: FeaturedMedia) =>
                        setSelectedMedia(media)
                    }
                    style={{ padding: 0 }}
                    onSeeAllMedia={onSeeAllMedia}
                />
                <When condition={job?.description}>
                    <Body1>{job?.description}</Body1>
                </When>
            </When>
        </>
    );
};
